/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Cancel_Anytime_ProratedInputs */



/**
* | output |
* | --- |
* | "Cancel anytime · Prorated billing" |
*
* @param {Plan_Gate_Cancel_Anytime_ProratedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_cancel_anytime_prorated = /** @type {((inputs?: Plan_Gate_Cancel_Anytime_ProratedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Cancel_Anytime_ProratedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jederzeit kündbar · Anteilige Abrechnung")
	return /** @type {LocalizedString} */ ("Cancel anytime · Prorated billing")
});